import { Post } from './types';

export const getCarouselPostIds = (post?: Post): Array<string | number> => {
    if (post?.carousel && post.postIds?.length) {
        return post.postIds;
    }
    if (post?.id === undefined || post?.id === null) {
        return [];
    }
    return [post.id];
};

export const expandCarouselPosts = (
    postsById: Record<string | number, Post>,
    selectedIds: Array<string | number>,
): Array<string | number> => {
    const expandedIds = new Set<string | number>();
    selectedIds.forEach(id => {
        getCarouselPostIds(postsById[id]).forEach(postId => {
            expandedIds.add(postId);
        });
    });
    return Array.from(expandedIds);
};

export const expandCarouselPostRecords = (
    postsById: Record<string | number, Post>,
    selectedIds: Array<string | number>,
): Record<string | number, Post> => {
    return selectedIds.reduce((acc, id) => {
        const post = postsById[id];
        if (!post) return acc;
        if (post.carousel && post.carouselSlides?.length) {
            post.carouselSlides.forEach(slide => {
                acc[slide.id] = slide;
            });
            return acc;
        }
        acc[post.id] = post;
        return acc;
    }, {} as Record<string | number, Post>);
};
